
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sales-effectiveness/create",
      function () {
        return require("private-next-pages/sales-effectiveness/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sales-effectiveness/create"])
      });
    }
  